import { CART_MODULE } from "@/api_framework/api_config";
import { IUrgentCancelCheckoutResponse, IUrgentCancelSessionPayload } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setActiveCartId } from "@/app_redux/reducers/slices/auth/cart_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export type IUrgentCancelCheckoutResult = { status: boolean; cartId: string | null };

/** Commits the urgent-cancel session: cancels the invoice and returns the new cart. */
export const useUrgentCancelCheckoutAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError, toastNotification } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (payload: IUrgentCancelSessionPayload): Promise<IUrgentCancelCheckoutResult> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: IUrgentCancelCheckoutResult = await axios
          .post(`${CART_MODULE?.URGENT_CANCEL_CHECKOUT?.baseURL}`, payload, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IUrgentCancelCheckoutResponse>) => {
            if (res.data.status === true) {
              const cartId = res.data.data?.cart_id ?? null;
              toastNotification(res.data.message);
              if (cartId) dispatch(setActiveCartId(cartId));
              return { status: true, cartId };
            }
            return { status: false, cartId: null };
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config?.["curlCommand"]);
            captureError(e);
            return { status: false, cartId: null };
          });
        return response;
      } catch (e: any) {
        captureError(e);
        return { status: false, cartId: null };
      }
    },
    [dispatch],
  );

  return { execute };
};
